import gql from 'graphql-tag'

export const UPDATE_USER_EVENT_ROLE = gql`
  mutation updateUserEventRole(
    $organizationSlug: String!
    $email: String!
    $eventId: Int!
    $role: UserEventRole!
  ) {
    updateUserEventRole(
      organizationSlug: $organizationSlug
      email: $email
      eventId: $eventId
      role: $role
    )
  }
`

export const DELETE_USER_EVENT = gql`
  mutation deleteUserEvent($organizationSlug: String!, $email: String!, $eventId: Int!) {
    deleteUserEvent(organizationSlug: $organizationSlug, email: $email, eventId: $eventId)
  }
`
